module.exports = __webpack_public_path__ + "img/press-09.408258cb.jpeg";